import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step10 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("communication");

  const handleOptionClick = (value) => {
    onAnswer("communication", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>
          How often do you usually communicate with other people?
        </QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="communication"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step10;
